import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
const FIRST_DELAY = 6000;
const SHOW_MS = 5000;
const GAP_MS = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(() => Math.floor(Math.random() * recentBuyers.length));
  const [visible, setVisible] = useState(false);
  const [minutes, setMinutes] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let cycleTimer: number;
    const show = () => {
      setIndex(i => (i + 1 + Math.floor(Math.random() * 3)) % recentBuyers.length);
      setMinutes(1 + Math.floor(Math.random() * 14));
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        cycleTimer = window.setTimeout(show, GAP_MS);
      }, SHOW_MS);
    };
    cycleTimer = window.setTimeout(show, FIRST_DELAY);
    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(cycleTimer);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed bottom-28 left-3 right-3 z-50 sm:bottom-28 sm:left-5 sm:right-auto" aria-live="polite" data-id="element-273" data-mp="1fw24g0i2ufgz">
      <AnimatePresence data-id="element-274" data-mp="1ax7lmyk40qwv">
        {visible && !dismissed && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-2xl sm:w-[340px]" data-id="element-275" data-mp="n6bpjp8mf9jt">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-ok" data-id="element-276" data-mp="28imvezun4pk0">
              <ShoppingBagIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-277" data-mp="23l3j45hi6mup" />
            </span>
            <div className="min-w-0" data-id="element-278" data-mp="2aobgkvh5af07">
              <p className="text-[14px] leading-snug text-ink" data-id="element-279" data-mp="2fneapkvl70te">
                <strong data-id="element-280" data-mp="2fpr0ulbi0hhj">{buyer.name}</strong> from <strong data-id="element-281" data-mp="2kn0njt7i6f1o">{buyer.country}</strong> just bought the OBD2 Diagnostic
                Blueprint™
              </p>
              <p className="mt-0.5 text-xs text-slate-500" data-id="element-282" data-mp="2pksplg1v3hjl">
                {minutes} {minutes === 1 ? 'minute' : 'minutes'} ago · Verified purchase
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-md p-1 text-slate-400 transition-colors duration-150 hover:text-ink" aria-label="Dismiss notification" data-id="element-283" data-mp="1wwn58uepzuka">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-284" data-mp="197u3uifbwuia" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}